// Specialist links: any page of the site with ?ref=<code>, such as
// bossdrop.ai/?ref=jane-smith or bossdrop.ai/book-a-demo?ref=jane-smith.
// The first link a browser arrives on is kept until 90 days after its latest
// visit, and goes with what that visitor sends us: a demo booking, the sales
// form, the contact form. It lives in that one browser, so the terms ask
// specialists to register the company in their dashboard as well.
// It travels inside text those forms already carry, so it reaches Eric's
// calendar event and the team's email with no backend change. Eric issues the
// codes; a code he didn't issue is simply not credited.

const KEY = "bd_ref";
export const REF_WINDOW_MS = 90 * 86400000;
const CODE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

// Storage can be blocked, and a visitor we ask first hasn't allowed it yet. This
// keeps the code until the page reloads.
let memory = null;

function mayKeep() {
  const consent = window.bdConsent;
  return consent ? consent.permitted("referrals") : true;
}

function saved() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return memory;
}

function save(entry) {
  if (mayKeep()) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(entry));
      return;
    } catch {}
  }
  memory = entry;
}

/** Follows a visitor's choice: stores a code they just allowed, or forgets one they turned off. */
export function syncRefWithChoices() {
  if (!mayKeep()) {
    try {
      window.localStorage.removeItem(KEY);
    } catch {}
    return;
  }
  if (memory) {
    const entry = memory;
    memory = null;
    save(entry);
  }
}

window.addEventListener("bd:consent", syncRefWithChoices);
window.addEventListener("bd:asked", syncRefWithChoices);

/** The code this browser came in on, or "" when there is none or it has run out. */
export function currentRef(nowMs = Date.now()) {
  const entry = saved();
  return entry?.code && nowMs - entry.at < REF_WINDOW_MS ? entry.code : "";
}

/** Keeps ?ref= from the address. The first link wins, and coming back through it restarts its 90 days. */
export function captureRef(search = window.location.search, nowMs = Date.now()) {
  let code = "";
  try {
    code = String(new URLSearchParams(search).get("ref") || "").trim().toLowerCase();
  } catch {}
  if (!CODE.test(code)) return;
  const current = currentRef(nowMs);
  if (current && current !== code) return;
  save({ code, at: nowMs });
}

/**
 * A form's free text with the code in front, where a length limit can't cut
 * it off (the booking's "heard about" line stops at 200 characters). Without
 * a code the text is untouched.
 */
export function withRef(text, nowMs = Date.now()) {
  const code = currentRef(nowMs);
  if (!code) return text;
  const clean = String(text == null ? "" : text).trim();
  return clean ? `Specialist link: ${code}. ${clean}` : `Specialist link: ${code}`;
}
